import { useCallback, useMemo, useState } from 'react';

export const useKeeperBanner = (
    keeperActiveTypes: string[],
    selectedChallengeId?: string,
    challengeKeeperKey?: string
) => {
    const [closedBanners, setClosedBanners] = useState<Set<string>>(new Set());
    const [isOpenKeeperBanner, setIsOpenKeeperBanner] = useState(true);

    const filteredKeeperActiveTypesForBanner = useMemo(() => {
        return keeperActiveTypes.filter(
            (type) =>
                selectedChallengeId &&
                !closedBanners.has(`${challengeKeeperKey}-${selectedChallengeId}-${type}-banner`) &&
                localStorage.getItem(`${challengeKeeperKey}-${selectedChallengeId}-${type}-banner`) !== 'closed'
        );
    }, [keeperActiveTypes, closedBanners, selectedChallengeId, challengeKeeperKey]);

    const handleCloseKeeperBannerAction = useCallback(
        (currentBannerType?: string) => {
            if (!currentBannerType || !selectedChallengeId) {
                return;
            }
            const currentBannerKey = `${challengeKeeperKey}-${selectedChallengeId}-${currentBannerType}-banner`;

            localStorage.setItem(currentBannerKey, 'closed');
            setClosedBanners((prev) => new Set(prev).add(currentBannerKey));
            setIsOpenKeeperBanner(false);

            setTimeout(() => {
                setIsOpenKeeperBanner(true);
            }, 300);
        },
        [selectedChallengeId, challengeKeeperKey]
    );

    return {
        filteredKeeperActiveTypesForBanner,
        isOpenKeeperBanner,
        handleCloseKeeperBannerAction,
    };
};
